import { useCallback } from 'react'
import Lottie from 'react-lottie'

import { ButtonProps, Card, H3, H6 } from '@blueprintjs/core'

import PrimaryButton from '../primaryButton/PrimaryButton'
import styles from './Empty.module.scss'
import cameraLottie from './lottie/camera.lottie.json'
import cardLottie from './lottie/card.lottie.json'
import errorLottie from './lottie/error.lottie.json'
import linkLottie from './lottie/link.lottie.json'
import profileLottie from './lottie/profile.lottie.json'
import verifyLottie from './lottie/verify.lottie.json'

export default ({
    className,
    lottie,
    title,
    description,
    buttonProps,
}: {
    className?: string
    lottie: 'camera' | 'card' | 'error' | 'link' | 'profile' | 'verify'
    title: React.ReactNode
    description: React.ReactNode
    buttonProps?: ButtonProps
}) => {
    const animation = useCallback(() => {
        switch (lottie) {
            case 'camera': return cameraLottie
            case 'card': return cardLottie
            case 'error': return errorLottie
            case 'link': return linkLottie
            case 'profile': return profileLottie
            case 'verify': return verifyLottie
        }
    }, [lottie])

    const size = useCallback(() => {
        switch (lottie) {
            case 'camera': return 200
            case 'card': return 200
            case 'error': return 200
            case 'link': return 160
            case 'profile': return 140
            case 'verify': return 140
        }
    }, [lottie])

    return <>
        <Card className={`${styles.card} ${className}`}>
            <Lottie
                isClickToPauseDisabled
                width={size()}
                height={size()}
                options={{
                    loop: true,
                    autoplay: true,
                    animationData: animation(),
                    rendererSettings: {
                        className: styles.lottie,
                        preserveAspectRatio: 'xMidYMid slice',
                        progressiveLoad: false,
                        hideOnTransparent: true,
                    }
                }} />
            <H3 className={styles.label}>{title}</H3>
            <H6 className={styles.description}>{description}</H6>
            {buttonProps && <PrimaryButton {...buttonProps} />}
        </Card >
    </>
}